import * as React from 'react';
import { BigPet, Bike, MediumPet, PetInHold, Serfing, SmallPet, SnowBoard } from '@websky/core';
const MusicalInstrument = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 500 500" },
    React.createElement("path", { className: "cls-1", fill: "none", d: "M266.82,410H231a8.51,8.51,0,0,1-8.5-8.5v-9.37H200.27v9.37a8.51,8.51,0,0,1-8.5,8.5H179.2v9.89H282.81V410h-16Z" }),
    React.createElement("path", { className: "cls-2", fill: "currentColor", d: "M397.25,179.52c-3.5-7.25-11.21-11.41-21.15-11.41-9.28,0-16.82,3.44-24.11,6.77s-14,6.4-22.77,6.4c-25.7,0-33.38-15.7-43.1-35.57-9.58-19.59-21.5-44-56.07-44a8.5,8.5,0,0,0-8.5,8.5c0,.22,0,.43,0,.64v49.43a6,6,0,0,0,12,0V118.87a33.49,33.49,0,0,1,16.46,5V233.47a6,6,0,1,0,12,0V136.8a170.13,170.13,0,0,1,8.81,16.37c9.49,19.4,21.22,43.37,54.69,45v42.56a6,6,0,0,0,12,0V197.63c8.43-1.33,15.29-4.45,21.51-7.29s11.46-5.23,17.05-5.23c3,0,5.31.7,5.84,1.8.93,1.94.19,8.77-9.34,20.75-11.53,14.5-48.05,76-63.21,101.74-.42.72-36.95,62.79-47.81,83.56H239.5v-9.37a8.49,8.49,0,0,0-8.5-8.5H208.8V89.29a8.45,8.45,0,0,0-.43-2.68H242.7a8.5,8.5,0,0,0,0-17H181.87a8.5,8.5,0,0,0-8.19,10.76l3.09,11.19A8.5,8.5,0,0,0,185,97.79h6.84v277.3h0a8.49,8.49,0,0,0-8.5,8.5V393H170.7a8.5,8.5,0,0,0-8.5,8.5v26.89a8.5,8.5,0,0,0,8.5,8.5H291.31a8.5,8.5,0,0,0,8.5-8.5V401.46a8.5,8.5,0,0,0-8.5-8.5H280.84c21-37.94,89.45-155.08,105.07-174.72C401.35,198.83,400.6,186.47,397.25,179.52ZM282.81,419.85H179.2V410h12.57a8.51,8.51,0,0,0,8.5-8.5v-9.37H222.5v9.37A8.51,8.51,0,0,0,231,410h51.81Z" }),
    React.createElement("path", { className: "cls-2", fill: "currentColor", d: "M233.58,331.45v-143a6,6,0,0,0-12,0v143a6,6,0,0,0,12,0Z" }),
    React.createElement("path", { className: "cls-2", fill: "currentColor", d: "M297.48,283.64v-69.7a6,6,0,0,0-12,0v69.7a6,6,0,0,0,12,0Z" }),
    React.createElement("path", { className: "cls-2", fill: "currentColor", d: "M262,315.65v-45.8a6,6,0,0,0-12,0v45.8a6,6,0,1,0,12,0Z" })));
export const redwingsEquipmentIcons = {
    '0EF': Bike,
    '0EG': SnowBoard,
    '0EH': SnowBoard,
    '0EC': Bike,
    '0EI': Serfing,
    '0DD': SnowBoard,
    '0BT': PetInHold,
    '021': SmallPet,
    '0BS': MediumPet,
    '0AY': BigPet,
    '0PR': MusicalInstrument,
    '0HS': SnowBoard
};
export const REDWINGS_SORTING = [
    // Snow board
    '0EG',
    '0EH',
    '0DD',
    '0HS',
    // Serfing
    '0EI',
    // Bike
    '0EF',
    '0EC',
    // Musical
    '0PR',
    // Small pet
    '021',
    // Medium pet
    '0BS',
    // Pet in hold
    '0BT',
    // Big pet
    '0AY'
];
export const specialEquipmentItemsSort = (a, b) => {
    return (REDWINGS_SORTING.findIndex(value => { var _a; return value === ((_a = a[0]) === null || _a === void 0 ? void 0 : _a.rfics); }) -
        REDWINGS_SORTING.findIndex(value => { var _a; return value === ((_a = b[0]) === null || _a === void 0 ? void 0 : _a.rfics); }));
};
